import { render, staticRenderFns } from "./BaseBlackRockIcon.vue?vue&type=template&id=3fc5a6d9&scoped=true"
import script from "./BaseBlackRockIcon.vue?vue&type=script&lang=js"
export * from "./BaseBlackRockIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc5a6d9",
  null
  
)

export default component.exports